import { isRequestError } from '@atlaskit/media-client';

// Component name will be prefixed with "media-picker-" in logs. Check ufoExperiences in utils files

var packageName = "@atlaskit/media-picker";
var packageVersion = "70.0.9";
export function getPackageAttributes(componentName) {
  return {
    packageName: packageName,
    packageVersion: packageVersion,
    componentName: componentName,
    component: componentName
  };
}
export function getRequestMetadata(error) {
  if (error && isRequestError(error)) {
    return error.metadata;
  }
}